import {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
  ChangeEvent,
} from 'react'
import { MdPlayArrow } from 'react-icons/md'
import * as Yup from 'yup'

import { phoneMask, phoneRegExp } from 'shared/utils/formatters'
import Scaffold from 'shared/components/ScaffoldNew'
import { colors } from 'shared/styles/colors'
import Input from 'shared/components/Input'

import { useMotoristas } from '../../../../hooks/useMotoristas'
import { IPhoneComponentsProps } from './PhoneComponents.types'
import { Container, Title, ContainerForm, StyledForm } from './styles'

const Phone: FunctionComponent<IPhoneComponentsProps> = () => {
  const { handleBackButton, handleNextButton, loading } = useMotoristas()
  const [formOk, setFormOk] = useState(false)
  const { motoristas, setMotoristas } = useMotoristas()
  const [errorMessage] = useState('')
  const [phone] = useState(() => {
    if (motoristas && motoristas.telefone) {
      return motoristas.telefone
    }

    return ''
  })

  useEffect(() => {
    if (motoristas && motoristas.telefone) {
      setFormOk(true)
    }
  }, [motoristas, setFormOk])

  const handleChange = useCallback(
    async (e: ChangeEvent<HTMLInputElement>) => {
      setFormOk(false)
      const textValue = phoneMask(e.target.value)

      if (!textValue) {
        setMotoristas({ telefone: '' })

        return
      }

      try {
        const schema = Yup.object().shape({
          phone: Yup.string().required().min(15).matches(phoneRegExp),
        })

        await schema.validate(
          {
            phone: textValue,
          },
          {
            abortEarly: false,
          },
        )

        setMotoristas({ telefone: textValue })
        setFormOk(true)
      } catch (e) {
        setFormOk(false)
      }
    },
    [setMotoristas, setFormOk],
  )

  return (
    <Scaffold
      showFooterScaffold
      titleBackButton="Voltar"
      onClickBackButton={handleBackButton}
      icon={MdPlayArrow}
      titleNextButton="Próximo"
      onClickNextButton={handleNextButton}
      isNextButtonDisabled={!formOk}
      color={formOk ? colors.green : colors.gray}
      loading={loading}
      titleHeader="Novo motorista"
    >
      <Container>
        <Title>Telefone</Title>

        <StyledForm
          onSubmit={undefined}
          initialValues={{
            phone,
          }}
          validationSchema={() => ({
            phone: Yup.string().required('Telefone inválido!'),
          })}
        >
          {formControl => (
            <ContainerForm>
              <Input
                label="Qual é o celular do motorista?"
                placeholder="DDD + Número"
                name="phone"
                formControl={formControl}
                errorMessage={errorMessage}
                mask={value => phoneMask(value)}
                onChange={handleChange}
                maxLength={15}
                onPaste={handleChange}
              />
            </ContainerForm>
          )}
        </StyledForm>
      </Container>
    </Scaffold>
  )
}

export default Phone
